export default {"src":"/_next/static/media/calendarThree_40.e3cadd54.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};